import axios from "axios";
import { useState } from "react";

export function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");

  const validateForm = () => {
    const newErrors = {};

    if (formData.name.trim() === "") {
      newErrors.name = "Name is required";
    }

    if (
      !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        formData.email
      )
    ) {
      newErrors.email = "Invalid email address";
    }

    if (!/^[0-9]{10}$/.test(formData.phone)) {
      newErrors.phone = "Phone must be 10 digits long and contain only numbers";
    }

    if (formData.city.trim() === "") {
      newErrors.city = "City is required";
    }

    if (formData.message.trim() === "") {
      newErrors.message = "Message is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setErrorMessage("Please correct the errors in the form.");
      return false; // Prevent form submission
    } else {
      setErrors({});
      setErrorMessage("");
      return true; // Allow form submission
    }
  };

  const handleEmail = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      var data = {
        email: formData.email,
        phone: formData.phone,
        city: formData.city,
        name: formData.name,
        message: formData.message,
      };
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          access_key: "1ad7861f-67fb-48c3-9c4e-bf6c30d95715",
          ...data,
        }),
      });
      if (response.ok) {
        alert("Email sent");
      } else {
        alert("Oops... Something Went Wrong ");
      }
    }
  };

  return (
    <section className="contact-wrap-layout">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="contact-box-layout1">
              <h3 className="title title-bar-primary4">Leave Us Message</h3>

              <form
                onSubmit={handleEmail}
                className="contact-form-box"
                id="contact-form"
              >
                <div className="row">
                  <div className="col-md-12 form-group">
                    <input
                      type="text"
                      placeholder="First Name *"
                      className="form-control"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={(e) =>
                        setFormData({ ...formData, name: e.target.value })
                      }
                      required
                    />
                    {errors.name && (
                      <span className="error">{errors.name}</span>
                    )}
                  </div>
                  <div className="col-md-6 form-group">
                    <input
                      type="email"
                      placeholder="E-mail *"
                      className="form-control"
                      name="email"
                      id="email"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                      required
                    />
                    {errors.email && (
                      <span className="error">{errors.email}</span>
                    )}
                  </div>
                  <div className="col-md-6 form-group">
                    <input
                      type="text"
                      placeholder="Phone *"
                      className="form-control"
                      name="phone"
                      id="phone"
                      value={formData.phone}
                      onChange={(e) =>
                        setFormData({ ...formData, phone: e.target.value })
                      }
                      required
                    />
                    {errors.phone && (
                      <span className="error">{errors.phone}</span>
                    )}
                  </div>
                  <div className="col-md-12 form-group">
                    <input
                      type="text"
                      placeholder="City *"
                      className="form-control"
                      name="city"
                      id="city"
                      value={formData.city}
                      onChange={(e) =>
                        setFormData({ ...formData, city: e.target.value })
                      }
                      required
                    />
                    {errors.city && (
                      <span className="error">{errors.city}</span>
                    )}
                  </div>
                  <div className="col-12 form-group">
                    <textarea
                      placeholder="Message*"
                      className="textarea form-control"
                      name="message"
                      id="message"
                      value={formData.message}
                      onChange={(e) =>
                        setFormData({ ...formData, message: e.target.value })
                      }
                      rows="7"
                      cols="20"
                      required
                    ></textarea>
                    {errors.message && (
                      <span className="error">{errors.message}</span>
                    )}
                  </div>
                  <div className="col-12 form-group"></div>
                  <div className="col-12 form-group margin-b-none">
                    {errorMessage && <p className="error">{errorMessage}</p>}
                    <button type="submit" className="item-btn">
                      Submit Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="contact-box-layout1">
              <h3 className="title title-bar-primary4">
                Corporate Office Address
              </h3>
              <div className="contact-info">
                <ul>
                  <li>
                    <i className="bi bi-geo-alt-fill"></i>
                    <strong>
                      Marketing Office & Mfg Facility: <br />
                    </strong>{" "}
                    Plot No. C-251, Saykha GIDC Estate, Taluka : Vagara,
                    District: Bharuch-392140, Gujarat, India.
                  </li>
                  <li>
                    <i className="bi bi-envelope"></i> info@krufrenpharma.com
                  </li>
                  <li>
                    <i className="bi bi-telephone"></i> +91 9724421772
                  </li>
                </ul>
              </div>
              <h3 className="title title-bar-primary4">Follow Us</h3>
              {/* <ul>
                <li style={{ display: "inline-block", marginRight: "6px" }}>
                  <a
                    href="/"
                    target="_blank"
                    style={{
                      background: "#fff",
                      color: "#fff",
                      borderRadius: "17px",
                      width: "34px",
                      height: "34px",
                      display: "block",
                      textAlign: "center",
                      lineHeight: "34px",
                    }}
                  >
                    <i
                      style={{
                        fontSize: "3rem",
                        color: "#3b5998",
                      }}
                      className="bi bi-facebook"
                    ></i>
                  </a>
                </li>
                <li style={{ display: "inline-block", marginRight: "6px" }}>
                  <a
                    href="/"
                    target="_blank"
                    style={{
                      background: "#fff",
                      color: "#fff",
                      borderRadius: "17px",
                      width: "34px",
                      height: "34px",
                      display: "block",
                      textAlign: "center",
                      lineHeight: "34px",
                    }}
                  >
                    <i
                      style={{
                        fontSize: "3rem",
                        color: "#2aaae0",
                      }}
                      className="bi bi-twitter"
                    ></i>
                  </a>
                </li>
                <li style={{ display: "inline-block", marginRight: "6px" }}>
                  <a
                    href="/"
                    target="_blank"
                    style={{
                      background: "#fff",
                      color: "#fff",
                      borderRadius: "17px",
                      width: "34px",
                      height: "34px",
                      display: "block",
                      textAlign: "center",
                      lineHeight: "34px",
                    }}
                  >
                    <i
                      style={{
                        fontSize: "3rem",
                        color: "#0177b5",
                      }}
                      className="bi bi-linkedin"
                    ></i>
                  </a>
                </li>
              </ul> */}
            </div>
          </div>
          <div className="col-md-12" style={{ marginTop: "20px" }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3705.1767586630963!2d72.81192487699113!3d21.77341898006888!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395f87ea63b4dc71%3A0x805d5bba0ada0651!2sKrufren%20Pharma%20pvt%20ltd!5e0!3m2!1sen!2sin!4v1698399762049!5m2!1sen!2sin"
              width="100%"
              title="Google Maps Location"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
